import config from '@/config';
import {ApiBase, InternationalizedField, ListOptions} from '@/api/common';
import ApiList from '@/api/list';
import store, { Mutation } from '@/store';

const NO_UPLOAD_FIELDS = [
    'icon_link',
    'project_id',
];

export default class Project extends ApiBase<Project> {
    public static readonly SLUG: string = 'project';
    private static readonly URL_BASE: string = config.API_ROOT + '/project/';
    
    // Initializing these fields (even with undefined)
    public icon?: number|null = undefined;
    public icon_link?: string|null = undefined;
    public project_id?: string = undefined;
    public parent_project?: number = undefined;
    public order?: number = undefined;
    public name: InternationalizedField<string> = new InternationalizedField<string>();
    public description: InternationalizedField<string> = new InternationalizedField<string>();
    
    public constructor() {
        super({
            urlBase: Project.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }
    
    public assign(response: any): Project {
        super.assign(response);
        
        if (response) {
            if ('name' in response) {
                this.name = new InternationalizedField<string>(response.name);
            }
            if ('description' in response) {
                this.description = new InternationalizedField<string>(response.description);
            }
        }
        return this;
    }

    public static async get(id: number): Promise<Project> {
        return this.doGet({
            urlBase: Project.URL_BASE,
            id,
            create: (response) => new Project().assign(response),
        });
    }
    
    public static async list(): Promise<ApiList<Project>> {
        const options: ListOptions<Project> = {
            urlBase: Project.URL_BASE,
            create: (response) => new Project().assign(response),
            all: true,
            parameters: {
                minimal: true
            }
        };
        return this.doList(options);
    }

    public static async listAll(): Promise<ApiList<Project>> {
        return this.doList({
            urlBase: Project.URL_BASE,
            create: (response) => new Project().assign(response),
            all: true,
            parameters: {
                minimal: true
            }
        });
    }

    public getName(): string {
        const name = this.name.getDefaultValue();
        if (name) {
            return name;
        }
        return '';
    }
}
